import React, { createContext, useContext, useMemo, useState } from 'react'

const ChartContext = createContext(null)

const useChart = () => {
  const context = useContext(ChartContext)
  if (!context) {
    throw new Error('useCount must be used within a ChartProvider')
  }
  return context
}

const ChartProvider = props => {
  const [chart, setChart] = useState(null)

  const value = useMemo(() => ({ chart, setChart }), [chart])
  return <ChartContext.Provider value={value} {...props} />
}

export { ChartProvider, useChart }
